// Politique de remboursement et règlement du pari à 100 €.
//
// Le pari est un engagement commercial ferme : il doit être écrit avec ses
// conditions, sinon il est soit inopposable, soit ruineux. Ce texte dit
// exactement ce qui compte comme réussite et ce qui n'en est pas une.
import { Link } from 'react-router-dom'
import LegalShell from '../../components/urself/LegalShell'
import { COMPANY } from '../../lib/legal'
import { useT } from '../../lib/i18n'

export default function Refund () {
  const t = useT()
  const L = t.legal.refund
  const amount = t.legal.betAmount

  return (
    <LegalShell
      title={L.title}
      updated={L.updated}
      intro={L.intro(COMPANY.refundDays, amount)}
    >

      <h2>{L.refundT(COMPANY.refundDays)}</h2>
      <p>
        {L.refundP1a(COMPANY.refundDays)}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        {L.refundP1b}
      </p>
      <p>{L.refundP2}</p>

      <h2>{L.betT(amount)}</h2>
      <p>{L.betP(amount)}</p>

      <h3>{L.countsT}</h3>
      <ul>{L.countsItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h3>{L.notCountsT}</h3>
      <ul>
        {L.notCountsItems(COMPANY.removalDelayHours).map(x => <li key={x}>{x}</li>)}
      </ul>

      <h3>{L.claimT}</h3>
      <p>{L.claimP(t.legal.supportDelay)}</p>

      <h3>{L.limitsT}</h3>
      <ul>{L.limitsItems.map(x => <li key={x}>{x}</li>)}</ul>

      <h2>{L.notT}</h2>
      <p>
        {L.notP1}
        {L.notP2(COMPANY.removalDelayHours)}
        <Link to="/cgv">{L.notLink}</Link>.
      </p>
    </LegalShell>
  )
}
